export default __webpack_public_path__ + "static/media/WhereAreYouFrom_18.9c4f07b8.png";